/* eslint-disable max-lines-per-function */
/* eslint-disable functional/prefer-readonly-type */
import React from 'react'
import ErrorFallback from '~/components/ErrorFallback'
import Layout from '~/components/Layout'
import InternalHeader from '~/components/Layout/components/InternalHeader'
import InvolvedChart from '../components/QualifiersCharts/InvolvedChart'
import VehicleChart from '../components/QualifiersCharts/VehicleChart'
import { useHookstate } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import { ErrorBoundary } from 'react-error-boundary'
import { Divider, Grid, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import DrugsChart from '../components/QualifiersCharts/DrugsChart'
import WeaponChart from '../components/QualifiersCharts/Weapon'
import ObjectChart from '../components/QualifiersCharts/Object'
import {
  IListDispatchTab,
  InvolvedFilter,
  VehicleFilter,
  WeaponFilter,
  DrugsFilter,
  FilterState,
  SearchedState,
  OrgansFilter,
} from '../interfaces'
import AnimalsChart from '../components/QualifiersCharts/Animals'
import OrgansChart from '../components/QualifiersCharts/Organs'

export default function ManagementQualifiers() {
  const { translate } = useLang()
  const expandFilterSearch = useHookstate<boolean>(true)
  const tab = useHookstate<IListDispatchTab>('involved')

  const filters = useHookstate<FilterState>({
    involved: {},
    vehicle: {},
    weapon: {},
    drugs: {},
    objects: {},
    organs: {},
    animals: {},
  })

  // Centralized searched state for each tab with proper typing
  const searched = useHookstate<SearchedState>({
    involved: false,
    vehicle: false,
    weapon: false,
    drugs: false,
    objects: false,
    organs: false,
    animals: false,
  })

  const handleTabDispatch = (
    event: React.SyntheticEvent,
    value: IListDispatchTab
  ) => {
    tab.set(value)
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Layout marginLayout={true}>
        <InternalHeader title={translate('Qualifiers')} />
        <Grid item xs={12}>
          <TabContext value={tab.get()}>
            <TabList onChange={handleTabDispatch}>
              <Tab
                sx={{ width: '150px' }}
                label={translate('Involved')}
                value="involved"
              />
              <Tab
                sx={{ width: '150px' }}
                label={translate('Vehicle')}
                value="vehicle"
              />
              <Tab
                sx={{ width: '150px' }}
                label={translate('Weapons')}
                value="weapon"
              />
              <Tab
                sx={{ width: '150px' }}
                label={translate('Drugs')}
                value="drugs"
              />
              <Tab
                sx={{ width: '150px' }}
                label={translate('Objects')}
                value="objects"
              />
              <Tab
                sx={{ width: '150px' }}
                label={translate('Organs')}
                value="organs"
              />
              <Tab
                sx={{ width: '150px' }}
                label={translate('Animals')}
                value="animals"
              />
            </TabList>
            <Divider sx={{ marginTop: 2 }} />
            <TabPanel sx={{ padding: 0 }} value="involved">
              <InvolvedChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters: InvolvedFilter) =>
                  filters.involved.set(newFilters)
                }
                searched={searched.involved.get()}
                setSearched={(value: boolean) => searched.involved.set(value)}
              />
            </TabPanel>
            <TabPanel sx={{ padding: 0 }} value="vehicle">
              <VehicleChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters: VehicleFilter) =>
                  filters.vehicle.set(newFilters)
                }
                searched={searched.vehicle.get()}
                setSearched={(value: boolean) => searched.vehicle.set(value)}
              />
            </TabPanel>
            <TabPanel sx={{ padding: 0 }} value="weapon">
              <WeaponChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters: WeaponFilter) =>
                  filters.weapon.set(newFilters)
                }
                searched={searched.weapon.get()}
                setSearched={(value: boolean) => searched.weapon.set(value)}
              />
            </TabPanel>
            <TabPanel sx={{ padding: 0 }} value="drugs">
              <DrugsChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters: DrugsFilter) =>
                  filters.drugs.set(newFilters)
                }
                searched={searched.drugs.get()}
                setSearched={(value: boolean) => searched.drugs.set(value)}
              />
            </TabPanel>
            <TabPanel sx={{ padding: 0 }} value="objects">
              <ObjectChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters) => filters.objects.set(newFilters)}
                searched={searched.objects.get()}
                setSearched={(value) => searched.objects.set(value)}
              />
            </TabPanel>
            <TabPanel sx={{ padding: 0 }} value="organs">
              <OrgansChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters: OrgansFilter) =>
                  filters.organs.set(newFilters)
                }
                searched={searched.organs.get()}
                setSearched={(value: boolean) => searched.organs.set(value)}
              />
            </TabPanel>
            <TabPanel sx={{ padding: 0 }} value="animals">
              <AnimalsChart
                expandFilterSearch={expandFilterSearch}
                valueTab={tab.get()}
                filters={filters}
                setFilters={(newFilters) => filters.animals.set(newFilters)}
                searched={searched.animals.get()}
                setSearched={(value) => searched.animals.set(value)}
              />
            </TabPanel>
          </TabContext>
        </Grid>
      </Layout>
    </ErrorBoundary>
  )
}
